import React from "react";

import AuthCardLayout from "layouts/AuthCardLayout";

const ConfirmMail = () => (
  <AuthCardLayout>
    <div className="text-center">
      <h3>Email Confirmation Successful</h3>
      <div style={{ fontSize: "1rem", marginTop: "1rem" }}>
        Thank you for confirming your email address. Your registration request
        is now under review and will be processed within 24 hours. You will
        receive an email notification once the review is complete. If your
        registration is approved, you will be able to log in to and use the
        Application and Reporting Portal.
      </div>
    </div>
  </AuthCardLayout>
);

export default ConfirmMail;
